'use client';

import type { IconDefinition, SizeProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export {
  faChevronRight,
  faClock,
  faSearch,
  faChevronUp,
  faChevronLeft,
  faChevronDown,
  faExclamationCircle,
  faTruck,
  faCircleXmark,
  faMagnifyingGlassPlus,
  faMagnifyingGlassMinus,
  faCheck,
  faPaintBrush,
  faPen,
  faXmark,
  faGlobe,
  faArrowUpFromBracket,
  faArrowUpRightFromSquare,
  faCopy,
  faArrowsRotate,
  faPlus,
  faCirclePlus,
  faLink,
  faUser,
  faImage,
  faFilter,
  faSliders,
} from '@fortawesome/free-solid-svg-icons';

export { faCircleCheck } from '@fortawesome/free-regular-svg-icons';

export {
  faXTwitter,
  faInstagram,
  faYoutube,
  faTiktok,
  faFacebook,
} from '@fortawesome/free-brands-svg-icons';

type Props = {
  icon: IconDefinition;
  size?: SizeProp;
};

function FaIcon({ icon, size }: Props) {
  return <FontAwesomeIcon icon={icon} size={size} />;
}

export default FaIcon;
